import { useParams } from 'react-router-dom';
import { getZonaUrbana } from '@/lib/zoneUrbaneData';
import { DealerDetail } from '@/route-pages';
import ComproOroZonaUrbana from '@/pages/ComproOroZonaUrbana';
import NotFound from '@/pages/NotFound';


/**
 * Phase 4 router: discrimina fra landing zona urbana (whitelist) e DealerDetail.
 * URL pattern: /compro-oro/:city/:zona-or-dealer-id
 */
export function ComproOroZonaOrDealerRouter({ ssrContext }: { ssrContext?: any }) {
  const { city, zona } = useParams<{ city: string; zona: string }>();
  const z = getZonaUrbana(city || '', zona || '');

  if (z) {
    return (
      <ComproOroZonaUrbana
        ssrZona={z}
        ssrDealers={ssrContext?.zonaUrbanaDealers}
        ssrMetalPrices={ssrContext?.metalPrices}
        ssrQuotationsMap={ssrContext?.quotationsMap}
      />
    );
  }

  // Segmento non riconosciuto e nessun dealer risolto lato SSR → 404 reale
  if (ssrContext?.invalidDealerId) {
    return <NotFound />;
  }

  // Fallback: il secondo segmento è l'ID di un dealer

  return (
    <DealerDetail
      serverDealer={ssrContext?.dealer}
      serverMetalPrices={ssrContext?.metalPrices}
      serverRatings={ssrContext?.ratings}
      seoData={{
        dealer: ssrContext?.dealer,
        formattedCity: ssrContext?.formattedCity,
        ratings: ssrContext?.ratings,
        cityDealerCount: ssrContext?.cityDealerCount,
      }}
    />
  );
}
